import { Injectable, Signal, computed } from '@angular/core';

import { SelectOption } from '@core/ui';
import { CategoryTypeDescription } from '@mpcm/shared';

import { typeDescriptions } from '../consts';
import { ArticleRangeFilterType, _FieldArticleRangeFilterType } from '../models';

import { CategoryTypesService } from './category-types.service';

@Injectable()
export class FilterTypesService {
  readonly filterTypesSelectOptions: Signal<SelectOption<_FieldArticleRangeFilterType>[]> = computed<
    SelectOption<_FieldArticleRangeFilterType>[]
  >(() => this.mapCategoriesToFilterTypeSelectOptions());

  constructor(private readonly categoryTypesService: CategoryTypesService) {}

  private mapCategoriesToFilterTypeSelectOptions(): SelectOption<_FieldArticleRangeFilterType>[] {
    const availableCategories: CategoryTypeDescription[] = this.categoryTypesService.categoryTypesDescriptions();

    return Object.entries(typeDescriptions).map(([type, description]) => ({
      value: type as _FieldArticleRangeFilterType,
      label: description.label,
      icon: description.icon,
      disabled: type === ArticleRangeFilterType.Category && !availableCategories.length,
    }));
  }
}
